import { apiService } from './apiService';

export function getSalesReportService(data) {
    return apiService({
        method: 'POST',
        url: '/sales-report',
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function getItemsReportService(data) {
    return apiService({
        method: 'POST',
        url: '/items-report',
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}
export function getCreditBalanceReportService(data) {
  return apiService({
    method: 'POST',
    url: '/credit-balance-report',   // ← must match backend route
    data,
    onSuccess: () => {},
    onFailure: () => {},
  });
}